import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import { Format } from "devextreme-react/number-box";
import { Editing } from "devextreme-react/scheduler";
import { ButtonItem } from "devextreme-react/tree-list";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarParametrosRefisDs,
  criarDocumentosRetencaoDs,
  criarPrefeituraDs,
} from "../../DataSources";
import uiInfo from "../../ui-info";
import {
  Column,
  DataGrid,
  Paging,
  Pager,
  HeaderFilter,
  FilterRow,
  Lookup,
} from "devextreme-react/data-grid";
import PaginaToolbar from "../../components/PaginaToolbar";
import ShowError from "../../AppServices";

let _paramRefisCorrente;

const template = {
  id: undefined,
  prefeituraId: undefined,
  lei: "",
  dataInicial: "",
  dataFinal: "",
  valorParcelaMinimaPF: undefined,
  valorParcelaMinimaMEI: undefined,
  valorParcelaMinimaPJ: undefined,
  tipoEspecial: 0,
  descontos: [],
};

export default class ParametrosRefisForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    template.prefeituraId = UserInfo.getPrefeitura();
    this.parametrosRefisDs = criarParametrosRefisDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;

    this.tipoEspecialOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "NENHUM" },
        { id: 1, descricao: "SEMELHANTE RFB" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.tipoRequerenteOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: " " },
        { id: 1, descricao: "MEI" },
        { id: 2, descricao: "PESSOA FISICA" },
        { id: 3, descricao: "PESSOA JURIDICA" },
        { id: 4, descricao: "PESSOA JURIDICA OU MEI" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.simNaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: true, descricao: "SIM" },
        { id: false, descricao: "NAO" }
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.parametrosRefisDs
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (data == undefined) {
            notify("Parametro refis não encontrado.", "error");
            this.props.history.push("/refis");
          }
          this.setState(data);
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }

    if (this.props.match.params.id === undefined) {
      this.setState({ ...template });
    }
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <Form formData={this.state} colCount={2}>
          <GroupItem caption="PARAMETOS REFIS" colSpan={2} colCount={3}>
            <SimpleItem dataField={"lei"}>
              <Label text="Lei" />
            </SimpleItem>
            <SimpleItem
              dataField={"dataInicial"}
              editorType={"dxDateBox"}
              editorOptions={{ type: "date", width: "100%" }}
            >
              <Label text="Data Inicial" />
            </SimpleItem>

            <SimpleItem
              dataField={"dataFinal"}
              editorType={"dxDateBox"}
              editorOptions={{ type: "date", width: "100%" }}
            >
              <Label text="Data Final" />
            </SimpleItem>

            <SimpleItem
              dataField={"valorParcelaMinimaPF"}
              editorType={"dxNumberBox"}
              editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              cssClass={"txtNumerico"}
            >
              <Label text="Parcela Mín. PF (R$)" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>

            <SimpleItem
              dataField={"valorParcelaMinimaPJ"}
              editorType={"dxNumberBox"}
              editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              cssClass={"txtNumerico"}
            >
              <Label text="Parcela Mín. PJ (R$)" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>

            <SimpleItem
              dataField={"valorParcelaMinimaMEI"}
              editorType={"dxNumberBox"}
              editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              cssClass={"txtNumerico"}
            >
              <Label text="Parcela Mín. MEI (R$)" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>

            <SimpleItem
              dataField={"tipoEspecial"}
              editorType={"dxSelectBox"}
              editorOptions={this.tipoEspecialOptions}
            >
              <Label text="Tipo Especial" />
            </SimpleItem>

            <SimpleItem dataField={"parcelaFixa"}
              editorType={"dxSelectBox"}
              editorOptions={this.simNaoOptions}>
              <Label text="Parcela Fixa" />
            </SimpleItem>

            <SimpleItem
              dataField={"entradaSobreTotalDebitosSemDescontosRefis"}
              editorType={"dxSelectBox"}
              editorOptions={this.simNaoOptions}
            >
              <Label text="Entrada sobre débito original" />
            </SimpleItem>

            <SimpleItem
              dataField={"tipoRequerente"}
              editorType={"dxSelectBox"}
              colSpan={1}
              editorOptions={this.tipoRequerenteOptions}
            >
              <Label text="Tipo Requerente" />
            </SimpleItem>

            <SimpleItem
              dataField={"classificacoes"}
              colSpan={1}
              helpText="Seperados por vírgula, Ex: IPTU, ITBI, ISS"
            >
              <Label text="Classificações" />
            </SimpleItem>

            <SimpleItem
              dataField={"codigosLivro"}
              colSpan={1}
              helpText="Seperados por vírgula, Ex: T, NT, MOB, IMOB"
            >
              <Label text="Códigos Livro" />
            </SimpleItem>

          </GroupItem>
        </Form>

        <PaginaToolbar titulo="Parâmetros de parcelas e descontos">
          <DataGrid
            dataSource={this.state.descontos}
            showBorders={true}
            rowAlternationEnabled={true}
            wordWrapEnabled={true}
            onInitNewRow={this.initNewRow}
          >
            <Editing
              mode={"row"}
              allowAdding={false}
              allowUpdating={true}
              allowDeleting={true}
            />
            <Column
              dataField={"id"}
              caption={"#"}
              width={"150"}
              allowEditing={false}
              visible={false}
            />
            <Column
              dataField={"prefeituraId"}
              caption={"Prefeitura"}
              visible={false}
            />
            <Column
              dataField={"parametrosRefisId"}
              caption={"ParametroId"}
              visible={false}
            />
            <Column
              dataField={"valorMinimoDebito"}
              caption={"Débito Min. (R$)"}
              editorType={"dxNumberBox"}
              format={"#,##0.00"}
              editorOptions={{ format: "#,##0.00" }}
              cssClass="txtNumerico"
            />

            <Column
              dataField={"valorMaximoDebito"}
              caption={"Débito Máx. (R$)"}
              editorType={"dxNumberBox"}
              format={"#,##0.00"}
              editorOptions={{ format: "#,##0.00" }}
              cssClass="txtNumerico"
            />

            <Column
              dataField={"qtdeParcelaInicial"}
              caption={"Qtde Parcela Inicial"}
            />
            <Column
              dataField={"qtdeParcelaFinal"}
              caption={"Qtde Parcela Final"}
            />
            <Column
              dataField={"descValorParcelaMinimaPf"}
              caption={"Parcela Min. PF (R$)"}
              editorType={"dxNumberBox"}
              format={"#,##0.00"}
              editorOptions={{ format: "#,##0.00", min: 0 }}
              cssClass="txtNumerico"
            />
            <Column
              dataField={"descValorParcelaMinimaPj"}
              caption={"Parcela Min. PJ (R$)"}
              editorType={"dxNumberBox"}
              format={"#,##0.00"}
              editorOptions={{ format: "#,##0.00" }}
              cssClass="txtNumerico"
            />
            <Column
              dataField={"descValorParcelaMinimaMei"}
              caption={"Parcela Min. MEI (R$)"}
              editorType={"dxNumberBox"}
              format={"#,##0.00"}
              editorOptions={{ editorType: "dxNumberBox", format: "#,##0.00" }}
              cssClass="txtNumerico"
            />
            <Column
              dataField={"percentualMinEntrada"}
              caption={"Min. Entrada (%)"}
            />
            <Column
              dataField={"descontoPrincipal"}
              caption={"Desc. Principal (%)"}
            />
            <Column dataField={"descontoMulta"} caption={"Desc. Multa (%)"} />
            <Column dataField={"descontoJuros"} caption={"Desc. Juros (%)"} />
            <Column
              dataField={"descontoCorrecao"}
              caption={"Desc. Correção (%)"}
            />
            <Column dataField={"jurosParcela"} caption={"Juros Parcela (%)"} />
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>
        <br></br>
        <Form>
          <GroupItem colCount={6}>
            <ButtonItem
              horizontalAlignment={"left"}
              buttonOptions={{
                type: "success",
                text: "Salvar",
                onClick: this.ok,
              }}
            />
            <ButtonItem
              horizontalAlignment={"left"}
              buttonOptions={{
                type: "warn",
                text: "Cancelar",
                onClick: this.cancel,
              }}
            />
          </GroupItem>
        </Form>
      </div>
    );
  }

  initNewRow(e) {
    e.data.prefeituraId = UserInfo.getPrefeitura();
  }

  ok() {
    const entidade = this.state;
    console.log("entidade refis", entidade);
    inserirOuAtualizar(this.parametrosRefisDs, entidade)
      .then(
        function () {
          _paramRefisCorrente = undefined;
          notify("Parametro refis cadastrado com sucesso.", "success");
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _paramRefisCorrente = undefined;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
